"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.updateFormSettings = exports.loadFormSettings = void 0;

var _reduxObservable = require("redux-observable");

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var loadFormSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.get,
  initiatingActionType: _actions.FormSettingsActionType.LOAD_FORM_SETTINGS,
  requestStatusSelector: _selectors.getFetchFormSettingsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_ONCE,
  requestActions: _actions.FetchFormSettings
}));
exports.loadFormSettings = loadFormSettings;
var updateFormSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.set,
  initiatingActionType: _actions.FormSettingsActionType.UPDATE_FORM_SETTINGS,
  requestStatusSelector: _selectors.getUpdateFormSettingsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions.UpdateFormSettings
}));
exports.updateFormSettings = updateFormSettings;

var _default = (0, _reduxObservable.combineEpics)(loadFormSettings, updateFormSettings);

exports.default = _default;